package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.common.usecases.PartitionChapterUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions.BuildUserCompletionsModelUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions.RenderUserCompletionsUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions.ToggleUserBlankUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure.VerseOrHalfOrWordCompletionUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.features.shuffle.BuildShuffledVersesUseCase

interface ChapterCompleteUseCaseProvider {
    val buildSavedCompletionOutputUseCase: BuildSavedCompletionOutputUseCase
    val parseSavedCompletionDataUseCase: ParseSavedCompletionDataUseCase
    val buildLexicographicalTableHtmlUseCase: BuildLexicographicalTableHtmlUseCase
    val buildContentByExposureTypeDomainUseCase: BuildContentByExposureTypeDomainUseCase
    val partitionChapterUseCase: PartitionChapterUseCase
    val revealBlankUseCase: RevealBlankUseCase
    val buildUserCompletionsModelUseCase: BuildUserCompletionsModelUseCase
    val renderUserCompletionsUseCase: RenderUserCompletionsUseCase
    val toggleUserBlankUseCase: ToggleUserBlankUseCase
    val verseOrHalfOrWordCompletionUseCase: VerseOrHalfOrWordCompletionUseCase
    val buildShuffledVersesUseCase: BuildShuffledVersesUseCase
}

class ChapterCompleteUseCaseProviderImpl(
    override val buildSavedCompletionOutputUseCase: BuildSavedCompletionOutputUseCase,
    override val parseSavedCompletionDataUseCase: ParseSavedCompletionDataUseCase,
    override val buildLexicographicalTableHtmlUseCase: BuildLexicographicalTableHtmlUseCase,
    override val buildContentByExposureTypeDomainUseCase: BuildContentByExposureTypeDomainUseCase,
    override val partitionChapterUseCase: PartitionChapterUseCase,
    override val revealBlankUseCase: RevealBlankUseCase,
    override val buildUserCompletionsModelUseCase: BuildUserCompletionsModelUseCase,
    override val renderUserCompletionsUseCase: RenderUserCompletionsUseCase,
    override val toggleUserBlankUseCase: ToggleUserBlankUseCase,
    override val verseOrHalfOrWordCompletionUseCase: VerseOrHalfOrWordCompletionUseCase,
    override val buildShuffledVersesUseCase: BuildShuffledVersesUseCase,
) : ChapterCompleteUseCaseProvider
